import React from "react"
import "./SocialMedias.scss"

const SocialMedias = ({ staticNewsPage }) => {
  const [staticContent, setStaticContent] = React.useState([])

  React.useEffect(() => {
    if (staticNewsPage) {
      setStaticContent(staticNewsPage)
    }
  }, [])

  return (
    <div className="social-medias">
      <div className="row mt-5">
        <div className="col-lg-2" />
        <h1 className="col">
          <span className="blue-colored-element">
            {staticContent["Call-to-action row 1"]}
          </span>
          &nbsp;
          {staticContent["Call-to-action row 2"]}&nbsp;
          <span className="blue-colored-element">
            {staticContent["Call-to-action row 3"]}
          </span>
        </h1>
      </div>

      <div className="row my-4">
        <div className="empty-space col-lg-2" />
        <h3 className="col-lg-2 facebook-link curs-P">
          <a target="_blank" href={staticContent["FB link"]}>
            facebook
          </a>
        </h3>
        <h3 className="col-lg-2  instagram-link curs-P">
          <a target="_blank" href={staticContent["Instagram link"]}>
            instagram
          </a>
        </h3>
        <h3 className="col-lg-2 youtube-link curs-P">
          <a target="_blank" href={staticContent["YuoTube link"]}>
            youtube
          </a>
        </h3>
        <h3 className="col-lg-2 linkedin-link curs-P">
          <a target="_blank" href="https://www.linkedin.com/company/bigmediaua">
            linkedin
          </a>
        </h3>
      </div>
    </div>
  )
}

export default SocialMedias
